import { useLocalOrRemoteCustomer as useLocalOrRemoteCustomerBase } from '@monofront/business/contexts';
import { useAuthentication } from '@context/businessContainer';
import { useLocalStorage } from '@monofront/business/hooks';

export const useLocalOrRemoteCustomer = () =>
  useLocalOrRemoteCustomerBase({ useAuthentication, useLocalStorage });
